import { Stack as MuiStack, StackProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type { StackProps };

export const Stack: React.ComponentType<StackProps> = styled(MuiStack)<StackProps>(() => ({}));
